<template>
  <div class="login-container">
    <div class="login-wrapper">
      <!-- Left side - Image/Branding -->
      <div class="login-left">
        <div class="brand-content">
          <div class="logo-section">
            <h1 class="brand-title">Gstocky</h1>
            <p class="brand-subtitle">{{ $t('manage_your_business') }}</p>
          </div>
          <div class="features-list">
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('inventory_management') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('crm_customer_relations') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('sales_invoicing') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('purchases_suppliers') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('point_of_sale') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('payment_management') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('attachments_documents') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('subscriptions_billing') }}</span>
            </div>
            <div class="feature-item">
              <AppIcon name="bi-check-circle-fill" class="bi bi-check-circle-fill" />
              <span>{{ $t('and_much_more') }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side - Login Form -->
      <div class="login-right">
        <div class="login-form-container">
          <div class="form-header">
            <div class="mobile-brand">Gstocky</div>
            <p class="form-subtitle">{{ $t('connect_to_your_account') }}</p>
          </div>

          <form @submit.prevent="login" class="login-form">
            <GoogleLoginButton
              text="signin_with"
              @success="loginWithGoogle"
              @error="showGoogleError"
            />

            <div class="auth-divider">
              <span>{{ $t('or') }}</span>
            </div>

            <div class="form-group">
              <label for="email" class="form-label">
                {{ $t('email') }} <span class="required">*</span>
              </label>
              <div class="input-wrapper">
                <AppIcon name="bi-envelope" class="bi bi-envelope input-icon" />
                <input
                  id="email"
                  type="email"
                  v-model="email"
                  :placeholder="$t('email')"
                  class="form-input"
                  required
                />
              </div>
            </div>

            <div class="form-group">
              <label for="password" class="form-label">
                {{ $t('password') }} <span class="required">*</span>
              </label>
              <div class="input-wrapper">
                <AppIcon name="bi-lock" class="bi bi-lock input-icon" />
                <input
                  id="password"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  :placeholder="$t('password')"
                  class="form-input"
                  required
                />
                <AppIcon :name="showPassword ? 'bi-eye-slash' : 'bi-eye'"
                  class="bi password-toggle"
                  :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"
                  @click="showPassword = !showPassword"
                 />
              </div>
            </div>

            <button
              type="submit"
              class="login-btn"
              :disabled="loading"
              :class="{ 'loading': loading }"
            >
              <span v-if="loading" class="loading-spinner"></span>
              <span v-else>{{ $t('login') }}</span>
            </button>

            <div class="links-section">
              <router-link to="/signup" class="signup-link">
                {{ $t('dont_have_an_account') }}
              </router-link>
              <router-link to="/reset-password" class="forgot-link">
                {{ $t('forgot_your_password') }}
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import helper from '../helper'
import GoogleLoginButton from '../components/GoogleLoginButton.vue'
export default {
  name: 'Login',
  components: {
    GoogleLoginButton
  },
  mounted(){
    window.mixpanel.track("login");
    document.title = 'Se Connecter | Gstocky';
  },
  data(){
    return {
        email : '',
        password : '',
        loading : false,
        showPassword: false
    }
  },
  created(){
    localStorage.removeItem('access_token')
    localStorage.removeItem('navFullSize')
  },
  methods : {
    async login(){
         if(this.email == '' || this.password == ''){
          window.vueOpener.open({
            message: this.$t('please_complete_all_required_fields'),
            type: 'warning',
            position : 'bottom'
          });
          return;
        }
        this.loading = true
        /* window.grecaptcha.ready(() => {
          window.grecaptcha.execute('6LetDZEmAAAAAEr9EdTVoDeg6-saEQYhXVSlrQhO', {action: 'submit'})
              .then( async (token) => {
                if(token){ */

                    try{
                        this.loading = true
                        const response = await helper.customPost(`${process.env.VUE_APP_API}/login`,
                        {
                          email : this.email,
                          password : this.password,
                          // token : token
                        })

                        if (response.data.two_factor_required) {
                            this.loading = false
                            this.$router.push({ path: '/2fa', query: { token: response.data.temp_token } })
                            return
                        }

                        this.loading = false
                        this.$store.commit('SET_TOKEN',response.data.access_token)
                        this.$store.commit('SET_REFRESH_TOKEN',response.data.refresh_token)
                        helper.setUserConnectedCookie()
                        this.$toast.open({
                            message: this.$t('logged_in'),
                            type: 'success',
                            position : 'bottom'
                        });
                        const savedRedirect = sessionStorage.getItem('post_login_redirect')
                        const redirect = savedRedirect && savedRedirect.startsWith('/oauth/authorize?') ? savedRedirect : '/'
                        sessionStorage.removeItem('post_login_redirect')
                        window.location.href = redirect

                    }catch(error){
                      this.loading = false
                    }
                /* }
              })
              .catch(() => {
                this.loading = false
              })
        }); */
    },

    async loginWithGoogle(credential){
      try{
        this.loading = true
        const response = await helper.customPost(`${process.env.VUE_APP_API}/auth/google`, {
          credential
        })

        if (response.data.two_factor_required) {
          this.loading = false
          this.$router.push({ path: '/2fa', query: { token: response.data.temp_token } })
          return
        }

        this.loading = false
        this.$store.commit('SET_TOKEN',response.data.access_token)
        this.$store.commit('SET_REFRESH_TOKEN',response.data.refresh_token)
        helper.setUserConnectedCookie()
        this.$toast.open({
          message: this.$t('logged_in'),
          type: 'success',
          position : 'bottom'
        });
        const savedRedirect = sessionStorage.getItem('post_login_redirect')
        const redirect = savedRedirect && savedRedirect.startsWith('/oauth/authorize?') ? savedRedirect : '/'
        sessionStorage.removeItem('post_login_redirect')
        window.location.href = redirect
      }catch(error){
        this.loading = false
        this.showGoogleError(error)
      }
    },

    showGoogleError(error){
      window.vueOpener.open({
        message: error.response?.data?.message || this.$t('google_signin_failed'),
        type: 'error',
        position : 'bottom'
      });
    },

  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  /* background: #004aad; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-wrapper {
  display: flex;
  max-width: 1200px;
  width: 100%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(1, 22, 50, 0.15);
}

.login-left {
  flex: 1;
  background: #004aad;
  color: white;
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-content {
  text-align: center;
}

.brand-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 10px;
  background: linear-gradient(45deg, #fff, #e6f0ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 1.2rem;
  margin-bottom: 40px;
  opacity: 0.9;
}

.features-list {
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 1.1rem;
}

.feature-item .app-lucide-icon {
  color: #00d4aa;
  flex: 0 0 auto;
  font-size: 1.3rem;
}

.login-right {
  flex: 1;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form-container {
  width: 100%;
  max-width: 400px;
}

.form-header {
  text-align: center;
  margin-bottom: 28px;
}

.mobile-brand {
  display: none;
  color: #004aad;
  font-size: 1.4rem;
  font-weight: 800;
  margin-bottom: 12px;
}

.form-title {
  font-size: 2rem;
  font-weight: 700;
  color: #004aad;
  margin-bottom: 10px;
}

.form-subtitle {
  color: #6b7280;
  font-size: 1rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.required {
  color: #ef4444;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #004aad;
  font-size: 1.1rem;
}

.form-input {
  width: 100%;
  padding: 12px 40px 12px 40px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s;
  background: #f9fafb;
}

.form-input:focus {
  outline: none;
  border-color: #004aad;
  background: white;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

.password-toggle {
  position: absolute;
  right: 12px;
  cursor: pointer;
  color: #6b7280;
  font-size: 1.1rem;
  transition: color 0.3s;
  z-index: 10;
}

.password-toggle:hover {
  color: #004aad;
}

.login-btn {
  background: #004aad;
  color: white;
  border: none;
  padding: 16px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.auth-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #6b7280;
  font-size: 0.85rem;
}

.auth-divider::before,
.auth-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e5e7eb;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.links-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  margin-top: 20px;
}

.signup-link,
.forgot-link {
  color: #004aad;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s;
}

.signup-link:hover,
.forgot-link:hover {
  color: #0056d6;
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-container {
    min-height: 100svh;
    padding: 0;
    align-items: stretch;
    background: white;
  }

  .login-wrapper {
    display: block;
    max-width: 100%;
    border-radius: 0;
    box-shadow: none;
  }

  .login-left {
    display: none;
  }

  .login-right {
    min-height: 100svh;
    padding: 30px 20px 18px;
    align-items: flex-start;
  }

  .login-form-container {
    max-width: 460px;
    margin: 0 auto;
  }

  .mobile-brand {
    display: block;
  }

  .form-header {
    margin-bottom: 18px;
  }

  .form-title {
    font-size: 1.65rem;
    margin-bottom: 4px;
  }

  .form-subtitle {
    font-size: 0.92rem;
  }

  .features-list {
    display: none;
  }

  .login-form {
    gap: 14px;
  }

  .form-label {
    margin-bottom: 6px;
    font-size: 0.82rem;
  }

  .form-input {
    padding-top: 11px;
    padding-bottom: 11px;
    border-radius: 8px;
  }

  .login-btn {
    min-height: 46px;
    padding: 12px;
    border-radius: 8px;
  }

  .links-section {
    margin-top: 4px;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 0;
  }

  .login-right {
    padding: 26px 16px 16px;
  }

  .form-title {
    font-size: 1.45rem;
  }
}
</style>
